

function InitGTMVideoClick()
{
  initVideoLinkClick();
  initVideoTagClick();
  
}

function initVideoLinkClick() {
  let links = document.querySelectorAll('a');
  if(!links) return;
  links.forEach((el) => {
    el.addEventListener('click', (e) => {
      if(!e || !e.target || !e.target.href || !e.target.href.toLowerCase().indexOf('youtube.com')) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'video',
        'title': e.target.innerText,
        'target': e.target.href
      });
    });
  });
}

function initVideoTagClick() {
  let videos = document.querySelectorAll('video');
  if(!videos) return;
  videos.forEach((el) => {
    el.addEventListener('playing', (e) => {
      if(!e || !e.target || !e.target.href) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'video',
        'title': e.target.innerText,
        'url': e.target?.querySelector('source')?.src
      });
    });
  });
}

InitGTMVideoClick();